<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.55255 36.8485C6.49648 37.9045 6.49648 39.6168 7.55255 40.6729L30.0878 63.2082C31.1439 64.2639 32.8561 64.2639 33.9122 63.2082L56.4474 40.6729C57.5035 39.6168 57.5035 37.9046 56.4474 36.8485C55.3914 35.7924 53.6792 35.7924 52.6231 36.8485L34.7042 54.7672V2.70423C34.7042 1.21073 33.4935 6.52856e-08 32 0C30.5065 -6.52802e-08 29.2958 1.21073 29.2958 2.70423V54.7672L11.3769 36.8485C10.3208 35.7924 8.60862 35.7924 7.55255 36.8485Z"
    />
  </g>
</template>
